import {DatagridPropsWithOptions} from "../../shared/types";
import {Datagrid, FunctionField, Link, linkToRecord, SelectField, TextField} from "react-admin";
import {initField} from "../../shared/utils";
import {Record} from "ra-core";
import {ApprovedField, ShowComment, ShowInvoiceLIneField} from "./Fields";
import {Chip} from "@material-ui/core";


export function ApprovedInvoicesDatagrid({options, ...rest}: DatagridPropsWithOptions) {
    return (
        <Datagrid {...rest}>
            <FunctionField
                label="Azienda"
                source="company_object"
                render={(record: Record | undefined) => {
                    if (record && record.company_object) {
                        return (
                            <Link to={linkToRecord("/subjects", record.company_object.company.id, "edit")}>
                                <TextField
                                    record={record.company_object}
                                    source="name"
                                    variant="inherit"

                                />
                            </Link>
                        );
                    }
                    return null;
                }}
                sortBy="company__company__business_name"
            />
            <FunctionField
                label="Fornitore"
                source="client__business_name"
                sortBy="client__business_name"
                render={(record: Record | undefined) => {
                    if (record) {
                        return (
                            <Link to={linkToRecord("/subjects", record.client_id, "edit")}>
                                <TextField
                                    record={record.client}
                                    source="business_name"
                                    variant="inherit"
                                />
                            </Link>
                        );
                    }
                    return null;
                }}
            />
            <SelectField
                {...initField("status", options, "array")}
                choices={options.status.choices}
            />
            <SelectField
                {...initField("invoice_type", options, "array")}
                choices={options.invoice_type.choices}
            />
            <SelectField
                {...initField("type", options, "array")}
                choices={options.type.choices}
            />
            <TextField {...initField("invoice_number", options)} />
            <TextField {...initField("taxable", options)}/>
            <FunctionField
                label="Righe fattura"
                render={
                    (record: Record | undefined) => {
                        return record ? <ShowInvoiceLIneField invoice_line={record.invoiceline_set}/> : null
                    }
                }/>
            <TextField {...initField("amount", options)}/>
            <FunctionField
                label="Stato"
                render={(record: Record | undefined) => {
                    return record ? (
                        record.approved === true ?
                            (<Chip style={{backgroundColor: "#2e7d32", color: "white"}} label="Approvata"/>
                            ) : (
                                record.invoicecomment_set.length > 0 ? (
                            <span><Chip style={{backgroundColor: "#c62828", color: "white"}} label="Rifutata"/> <ShowComment comments={record.invoicecomment_set}/> </span>) :
                            <ApprovedField id={Number(record.id)}/> )
                    ) : null
                }}/>
        </Datagrid>
    )
}